import { useTranslation } from 'react-i18next';

import { DistributionCenterBalanceItemDTO } from 'interfaces';
import { Divider } from 'storybook';

import SupplierPalletsNumberToPickUpItem from './SupplierPalletsNumberToPickUpItem/SupplierPalletsNumberToPickUpItem';
import styles from './SupplierPalletsNumberToPickUp.module.css';

type SupplierPalletsNumberToPickUpProps = {
   totalSum: DistributionCenterBalanceItemDTO;
   totalSumDifference: DistributionCenterBalanceItemDTO;
};

const SupplierPalletsNumberToPickUp = ({
   totalSum,
   totalSumDifference,
}: SupplierPalletsNumberToPickUpProps) => {
   const { t } = useTranslation();

   const { sum, invalid, valid } = totalSum;
   const {
      sum: sumDifference,
      invalid: invalidDifference,
      valid: validDifference,
   } = totalSumDifference;

   return (
      <div className={styles.container}>
         <SupplierPalletsNumberToPickUpItem
            title={t('supplierPalletsNumberToPickUp.valid')}
            palletsNumber={valid}
            palletsDifference={validDifference}
         />
         <SupplierPalletsNumberToPickUpItem
            title={t('edit_pallets.table.damaged')}
            palletsNumber={invalid}
            palletsDifference={invalidDifference}
         />
         <Divider variant="vertical" className={styles.divider} />
         <SupplierPalletsNumberToPickUpItem
            title={t('supplierPalletsNumberToPickUp.total')}
            palletsNumber={sum}
            palletsDifference={sumDifference}
            isSummary
         />
      </div>
   );
};

export default SupplierPalletsNumberToPickUp;
